import './user-menu.css';
import keyIcon from '../../imgs/key.png';
import whiteKeyIcon from '../../imgs/white-key.png';
import moonIcon from '../../imgs/moon.png';
import sunIcon from '../../imgs/sun.png';
import monitorIcon from '../../imgs/monitor.png';
import whiteMoonIcon from '../../imgs/white-moon.png';
import whiteSunIcon from '../../imgs/white-sun.png';
import whiteMonitorIcon from '../../imgs/white-monitor.png';
import UserPerfil from "../UserPerfil";
import { useState } from 'react';
import { logout } from '../../services/api';
import ChangePassword from "../ChangePassword";
import { useTheme } from '../../ThemeContext';
import { THEMES } from '../../constants/theme';

function UserMenu({ pos, showMenu, onPerfilClick = () => {}, onChangePassClick = () => {}, user }) {
    const [showPerfilModal, setShowPerfilModal] = useState(false);
    const [showChangePassModal, setShowChangePassModal] = useState(false);
    const { theme, resolvedTheme, saveTheme } = useTheme();
    const useWhiteThemeIcons = resolvedTheme === THEMES.DARK;

    function onClickOpenPerfilModal() {
        onPerfilClick();
        setShowPerfilModal(true);
    }

    function onClickOpenChangePassModal() {
        onChangePassClick();
        setShowChangePassModal(true);
    }

    function onClickLogout() {
        logout();
    }

    return (
        <>
            {showMenu && !!pos && (
                <div
                    style={{
                        position: "fixed",
                        top: pos.top,
                        right: pos.right,
                        zIndex: 9999,
                    }}
                    className='user-menu glass-effect-45'>
                    <div className="menu-item user-configs">
                        <h2>{user?.name + ' ' + user?.lastName}</h2>
                        <h3>{user?.email}</h3>
                        <button id='open-perfil' onClick={onClickOpenPerfilModal}>Gerenciar Perfil</button>
                    </div>

                    <hr />

                    <div className="menu-item user-theme">
                        <span>Aparência </span>
                        <div className='theme-options'>
                            <button
                                type='button'
                                title='Claro'
                                aria-label='Claro'
                                className={theme === THEMES.LIGHT ? 'active' : ''}
                                onClick={() => saveTheme(THEMES.LIGHT)}>
                                <img src={useWhiteThemeIcons ? whiteSunIcon : sunIcon} alt='Claro' />
                            </button>

                            <button
                                type='button'
                                title='Escuro'
                                aria-label='Escuro'
                                className={theme === THEMES.DARK ? 'active' : ''}
                                onClick={() => saveTheme(THEMES.DARK)}>
                                <img src={useWhiteThemeIcons ? whiteMoonIcon : moonIcon} alt='Escuro' />
                            </button>

                            <button
                                type='button'
                                title='Sistema'
                                aria-label='Sistema'
                                className={theme === THEMES.SYSTEM ? 'active' : ''}
                                onClick={() => saveTheme(THEMES.SYSTEM)}>
                                <img src={useWhiteThemeIcons ? whiteMonitorIcon : monitorIcon} alt='Sistema' />
                            </button>
                        </div>
                    </div>

                    <hr />

                    <div className="menu-item user-others">
                        <button className='open-change-pass' onClick={onClickOpenChangePassModal}>
                            <img src={useWhiteThemeIcons ? whiteKeyIcon : keyIcon} alt="chave" /> Alterar Senha
                        </button>
                    </div>

                    <hr />

                    <div className="menu-item user-logout">
                        <button onClick={onClickLogout}>Sair (Log Out)</button>
                    </div>
                </div>
            )}

            <UserPerfil showModal={showPerfilModal} onClose={() => setShowPerfilModal(false)} />
            <ChangePassword showModal={showChangePassModal} onClose={() => setShowChangePassModal(false)} />
        </>
    );
}

export default UserMenu;